import styled from 'styled-components'

export const StyledPreparedMessage = styled.div`
&.dchart__no_data{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    width: 100%;
    & .dchart__no_data__icon_text{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        & .miss_info_smile{
            width: 60px;
            height: 60px;
            @media (max-width: 460px){
                width: 40px;
                height: 40px;
            }
        }
        & span{
            margin-top: 10px;
            color: #B0B0B0;
            font-size: 14px;
            font-weight: 500;
            @media (max-width: 460px){
                font-size: 10px;
            }
        }
    }
}
`
